import { PersistConfig } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { coreApi } from '@cp/shared/api/core';
import { createDialogMiddleware } from '@cp/entities/dialog';
import type { IoContainer } from '@cp/shared/di';
import { NotPersistedRootState, createRootReducer } from './../slices';

interface ConfigureStoreOptions<S> {
  container: IoContainer;
  preloadedState?: S;
  persistConfig: PersistConfig<S>;
}

export const configureAppStore = ({ preloadedState, persistConfig, container }: ConfigureStoreOptions<NotPersistedRootState>) => {
  const rootReducer = createRootReducer(persistConfig);
  type State = ReturnType<typeof rootReducer>;
  const store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState as State,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .prepend(createDialogMiddleware({ container }))
        .concat(coreApi.middleware),
    devTools: true,
  });
  setupListeners(store.dispatch);
  return store;
};

/**
 * Store typings
 */
export type StoreType = Awaited<ReturnType<typeof configureAppStore>>;

export type RootState = ReturnType<StoreType['getState']>;
